import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import fetchDux from '../../state/fetch-dux';
import CookieLink from './CookieLink';
import HeaderCartDropdown from './HeaderCartDropdown';

const REACT_APP_SILVEROAK_LINK = `${process.env.REACT_APP_SILVEROAK_LINK}`;

class CustomToggle extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    document.body.classList.add(
      'headroom',
      'headroom--pinned',
      'headroom--top',
      'headroom--not-bottom'
    );
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    document.body.classList.remove(
      'headroom',
      'headroom--pinned',
      'headroom--unpinned',
      'headroom--top',
      'headroom--not-top',
      'headroom--not-bottom',
      'headroom--bottom'
    );
  }
  handleScroll = event => {
    if (window.scrollY === 0) {
      document.body.classList.add('headroom--pinned', 'headroom--top');
      document.body.classList.remove('headroom--unpinned', 'headroom--not-top');
    } else {
      document.body.classList.add('headroom--unpinned', 'headroom--not-top');
      document.body.classList.remove('headroom--pinned', 'headroom--top');
    }
    if (window.scrollY + window.innerHeight === document.body.scrollHeight) {
      document.body.classList.add('headroom--bottom');
      document.body.classList.remove('headroom--not-bottom');
    } else {
      document.body.classList.add('headroom--not-bottom');
      document.body.classList.remove('headroom--bottom');
    }
  };
  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }
  render() {
    return (
      <a href="" onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}

class HeaderMaster extends Component {
  constructor(props) {
    super(props);
    this.state = { show: false };
  }
  render() {
    const {
      user,
      postLogout,
      mobileMenu,
      isMobile,
      toggleMobileMenu
    } = this.props;
    const { show } = this.state;
    const toggleShow = () => this.setState({ show: !show });
    const hasUser = !!user;
    const handleLogout = () =>
      postLogout(null, null, null, () => show ? toggleShow() : null);
    return (
      <div className="master-header" style={{ display: 'block' }}>
        <a href="/" className="site-logo-mobile d-lg-none">TWOMEY</a>
        <div className="common-branding">
          <CookieLink
            href={`${REACT_APP_SILVEROAK_LINK}/`}
            label="Silver Oak"
            target="_blank"
            className="silveroak-brand"
          />
          <a href="https://timeless.wine/" className="timeless-brand" >
            Timeless
          </a>
        </div>
        <a
          onClick={toggleMobileMenu}
          className={`nav-toggler d-lg-none ${mobileMenu ? 'expanded' : ''}`}
        >
          <span />
          <span />
          <span />
        </a>
        <div className="master-nav">
          <Dropdown show={show} className="d-none d-lg-inline-block">
            <Dropdown.Toggle as={CustomToggle} onClick={toggleShow}>
              Account
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="dropdown-menu dropdown-menu-center my-account-menu"
            >
              <div className="dropdown-inner">
                {hasUser &&
                  <div
                    className="account-logged-in"
                    style={{ display: 'block' }}
                  >
                    <Link to="/account" className="dropdown-item">
                      Account Details
                    </Link>
                    <Link to="/account/edit-profile" className="dropdown-item">
                      Edit Profile
                    </Link>
                    <Link to="/account/my-orders" className="dropdown-item">
                      My Orders
                    </Link>
                    <Link
                      to="/account/club-information"
                      className="dropdown-item"
                    >
                      Membership
                    </Link>
                    <a
                      href="true"
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      Logout
                    </a>
                  </div>}
                {!hasUser &&
                  <div className="account-not-logged-in">
                    <Link to="/account/login" className="dropdown-item">
                      Login
                    </Link>
                    <Link to="/account/sign-up" className="dropdown-item">
                      Sign Up
                    </Link>
                  </div>}
              </div>
            </Dropdown.Menu>
          </Dropdown>

          <HeaderCartDropdown />

        </div>
      </div>
    );
  }
}

const mapState = state => {
  const { result: user } = state.postLogin.toJS();
  return {
    user
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postLogout: fetchDux.postLogout.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(HeaderMaster);
